import React from "react";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { get } from "lodash";
import {
  DataTable,
  SearchPropTypes,
  CompanyName
} from "MODULES/shared/components";
import { NoteTooltip } from "MODULES/shared/components/NoteTooltip";
import { shortDateYY, shortDateAndTimestamp } from "LIB/formatters/date";
import RepairStationStatus from "MODULES/companies/components/Search/RepairStationStatus";
import { WithCurrentUser } from "MODULES/session/decorators/withCurrentUser";
import ToggleButton from "./ToggleButton";
import { asyncRepairStationStatusLastVerified } from "../actions";

function renderRow(
  r,
  currentUser,
  repairStationStatusLastVerified,
  pushHistory
) {
  const approved = r.repair_station_status === "approved";
  const repairStationStatusUpdatedAt = shortDateYY(
    r.repair_station_status_updated_at
  );
  const repairStationStatusUpdatedBy = get(
    r.repair_station_status_updated_by,
    "full_name"
  );
  const updatedAt = shortDateAndTimestamp(
    get(r, "repair_station_status_verified_details.updated_at")
  );
  const updatedBy = get(
    r,
    "repair_station_status_verified_details.updated_by.name"
  );

  return (
    <tr
      key={r.id}
      className="clickable"
      onClick={() => pushHistory(`/companies/${r.id}`)}
    >
      <td>
        <CompanyName company={r} />
      </td>
      <td>{get(r, "primary_physical_address.city")}</td>
      <td>{get(r, "primary_physical_address.state")}</td>
      <td>{get(r, "primary_physical_address.country")}</td>
      <td>
        <RepairStationStatus status={r.repair_station_status} />
        {repairStationStatusUpdatedAt &&
          repairStationStatusUpdatedBy && (
            <NoteTooltip
              note={`${approved
                ? "Approved"
                : "Denied"} on ${repairStationStatusUpdatedAt} by ${repairStationStatusUpdatedBy}`}
              icon="fa-info-circle"
              color="rgba(255, 255, 255, 0.25)"
              placement="right"
            />
          )}
      </td>
      <td>
        <ToggleButton
          text="Verify"
          toggledText="Re-Verify"
          toggled={r.repair_station_status_verified_details !== null}
          canRemove
          currentUser={currentUser}
          handleClick={e => {
            repairStationStatusLastVerified(r);
            e.stopPropagation();
          }}
        />
        {updatedBy &&
          updatedAt && (
            <NoteTooltip
              note={`Updated by ${updatedBy} on ${updatedAt}`}
              icon="fa-info-circle"
              color="rgba(255, 255, 255, 0.25)"
              placement="right"
            />
          )}
      </td>
    </tr>
  );
}

export function Table({
  results,
  pushHistory,
  isLoading,
  currentUser,
  repairStationStatusLastVerified
}) {
  return (
    <DataTable loading={isLoading}>
      <DataTable.Head>
        <th>Name</th>
        <th>City</th>
        <th>State</th>
        <th>Country</th>
        <th>Approval Status</th>
        <th>Reverification</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(r =>
          renderRow(
            r,
            currentUser,
            repairStationStatusLastVerified,
            pushHistory
          )
        )}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  repairStationStatusLastVerified: PropTypes.func.isRequired,
  ...WithCurrentUser,
  ...SearchPropTypes
};

export default connect(
  state => ({
    currentUser: state.session.get("user").toJS()
  }),
  (dispatch, ownProps) => ({
    repairStationStatusLastVerified: company =>
      dispatch(asyncRepairStationStatusLastVerified(company)),
    pushHistory: push,
    refresh: ownProps.pageActions.expire
  })
)(Table);



// WEBPACK FOOTER //
// ./app/modules/ApprovedRepairStations/Search/Table.jsx